import axios from '../config';

const headers = {
   headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
   },
};

export const userAPI = () => {
   return axios.get(`/user`, { headers });
};

export const login = (credentials) => {
   credentials.user['session_info'] = {
      platform: 'web',
   };

   return axios.post(`/auth/login`, credentials, { headers });
};

export const signup = (credentials) => {
   credentials.user['session_info'] = {
      platform: 'web',
   };
   return axios.post(`/auth/signup`, credentials, { headers });
};

export const forgotpassword = (credentials) => {
   return axios.post(`/auth/forgotpassword`, credentials, { headers });
};

export const resetpassword = (credentials) => {
   return axios.put(`/auth/resetpassword`, credentials, { headers });
};

export const verfication = (credentials) => {
   const UserID = credentials.userID;
   delete credentials.userID;
   return axios.put(`/auth/verify/${UserID}`, credentials, { headers });
};

export const resendverfication = (credentials) => {
   const UserID = credentials.userID;
   delete credentials.userID;
   return axios.put(`/auth/resend/${UserID}`, { headers });
};

export const refreshToken = () => axios.post(`/auth/refreshtoken`);
